import { Box } from "@mui/material";
import { useAtom } from "jotai";
import { useEffect, useRef, useState } from "react";
import { toastOptionsAtom } from "../../../atoms";
import { InvoicePaymentInitiatePayload } from "../../../types";
import Loading from "../../common/loading/Loading";
import { useFetchAchSaleMutation } from "../../../api";

type Props = {
  payload: InvoicePaymentInitiatePayload | undefined;
  orgId: number;
};

export const AchSaleWithToken = ({ payload, orgId }: Props) => {
  const hasMutated = useRef(false);
  const [paymentCallbackUrl, setPaymentCallbackUrl] = useState<string>();
  const [, setToastOptions] = useAtom(toastOptionsAtom);
  const [isIframeLoading, setIsIframeLoading] = useState(true);
  const fetchAchSaleMutation = useFetchAchSaleMutation();

  useEffect(() => {
    if (!payload || hasMutated.current) {
      return;
    }

    const { omnitokenId, tokenId } = payload;

    if (omnitokenId === undefined || tokenId === undefined) {
      return;
    }

    hasMutated.current = true;

    setTimeout(() => {
      fetchAchSaleMutation.mutate({
        orgId,
        accountId: payload.accountId,
        invoiceNumber: payload.invoiceNumber,
        omnitokenId,
        tokenId,
        amount: payload.invoiceAmount,
        netTransactionId: payload.netTransactionId,
      });
    }, 100);
  }, [payload, orgId]);

  useEffect(() => {
    if (fetchAchSaleMutation.isSuccess) {
      const callBackUrl = fetchAchSaleMutation.data;
      setPaymentCallbackUrl(callBackUrl);
    }

    if (fetchAchSaleMutation.isError) {
      setToastOptions({
        open: true,
        message: "Something went wrong",
        severity: "error",
      });
    }
  }, [
    fetchAchSaleMutation.isSuccess,
    fetchAchSaleMutation.isError,
    fetchAchSaleMutation.data,
    setToastOptions,
  ]);

  return (
    <Box
      sx={{
        borderRadius: "10px",
        minHeight: "630px",
        py: "auto",
      }}
    >
      <iframe
        style={{
          height: "630px",
          width: "100%",
          border: "none",
        }}
        src={paymentCallbackUrl}
        onLoad={() => setIsIframeLoading(false)}
      />

      {(fetchAchSaleMutation.isLoading || isIframeLoading) && (
        <Loading
          message=" "
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2,
            backgroundColor: "rgba(255, 255, 255, 0.6)",
          }}
        />
      )}
    </Box>
  );
};
